import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import translate from '../../commonComponents/translate';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import Anchor from '../../commonComponents/Anchor';

/**
 * Landing page for orders paid through an external Stripe Payment Link
 * (BRAVON-6316). The admin sets the Payment Link's after-completion redirect
 * to /shop/external-payment-complete. The order is confirmed asynchronously by
 * the external Stripe webhook, so this page only tells the buyer the payment
 * is being processed and points them to their orders.
 */
function ShopExternalPaymentComplete({ t }) {
  return (
    <Title title={t('shop.externalPayment.title')}>
      <ContentContainer>
        <SubHeader title={t('shop.externalPayment.title')} />
        <div className="m-content shop mt-5">
          <div className="row mt-5">
            <div className="col-lg-12">
              <div className="m-portlet m-portlet--rounded m-portlet--rounded-force">
                <div className="m-portlet__body text-center">
                  <i
                    className="la la-check-circle"
                    style={{ fontSize: '64px', color: '#34bfa3' }}
                  />
                  <h3 className="mt-3">{t('shop.externalPayment.thanks')}</h3>
                  <p className="mt-2">{t('shop.externalPayment.message')}</p>
                  <div className="mt-4">
                    <Anchor
                      href="/shop/order"
                      className="btn m-btn--pill btn-theme btn-lg m-btn m-btn--custom"
                    >
                      {t('shop.externalPayment.viewOrders')}
                    </Anchor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

ShopExternalPaymentComplete.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(ShopExternalPaymentComplete);
